import * as moment from 'moment';

import { College } from './college.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Jure {
    static jsonMap = {
        id: 'id',
        nom: 'nom',
        college: { key: 'idCollege', converter: new (DataIdConverterFactory.build(College, 'colleges'))() },
        cahier: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        libelleCahier: 'libelleCahier',
        idsOperateurs: { key: 'idIntervenantList' },
        dateDerniereFormation: { key: 'dateDerniereFormation', converter: new DateConverter(), optional: true },
        mail: { key: 'mail', optional: true, default: '' }
    };

    id: number;
    nom: string;
    college: College;
    cahier: Cahier;
    libelleCahier: string;
    idsOperateurs: number[];
    dateDerniereFormation: moment.Moment;
    mail: string;

    operateurs: Operateur[];

    checked?: boolean;
}
